import { useEffect, useState } from 'react'

/**
 * SSR-safe media query hook. Defaults to `false` until mounted so the
 * first paint stays deterministic (mobile shell → desktop upgrade).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** Desktop institutional layout breakpoint (Tailwind `lg` = 1024px). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}
